enum StatementItemTypes {
  SPEND = "SPEND_CREDIT",
  SPEND_REFUND = "SPEND_CREDIT_REFUND",
  PERKS_GO_CASHBACK = "cashback",
  MANUAL_CREDIT = "MANUAL_CREDIT",
  SEND_CREDIT_AS_REWARD = "send-credit-as-reward",
  USE_CREDIT_TO_BUY_REWARD = "use-credit-to-buy-reward",
  TRANSFER_TO_REWARDS_WALLET = "transfer-to-rewards-wallet",
  TOP_UP_BANK_TRANSFER = "tenant-wallet-topup-bank-transfer",
  TOP_UP_CARD_PAYMENT = "tenant-wallet-topup-card-payment",
  NEW_TOP_UP_BANK_TRANSFER = "wallet-topup-bank-transfer",
  NEW_TOP_UP_CARD_PAYMENT = "wallet-topup-card-payment",
  REFUND_FROM_REWARDS_WALLET = "refund-from-rewards-wallet",
  SEND_CREDIT = "SEND_CREDIT",
  MANUAL_REFUND = "MANUAL_REFUND",
  SEND_CREDIT_AS_REWARD_REFUND = "send-credit-as-reward-refund",
  MONTHLY_TREAT_TOKEN_TOP_UP = "MonthlyTreatTokens",
  EXPIRE_TREAT_TOKENS = "ExpireTreatTokens",
  POINTS_BACK = "Pointsback",
  TOPUP = "TOPUP",
  TRANSFER = "TRANSFER",
  REWARD = "REWARD",
  TOP_UP_BANK_TRANSFER_FLEXI = "wallet-topup-bank-transfer-flexi",
  TOP_UP_CARD_PAYMENT_FLEXI = "wallet-topup-card-payment-flexi",
  TOP_UP_FLEXI = "TOPUP-flexi",
  REWARD_POINTS_EXPIRY = "EXPIRY"
}

export default StatementItemTypes
